module.exports = __webpack_public_path__ + "static/media/icon_mp_re.3e5a3548.svg";